// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3j_IL","range":"MonthRangeSwitch_range__jRzFT","disabled":"MonthRangeSwitch_disabled__3fZrV"};